import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Button,
  Card,
  IconButton,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Pagination from "../../components/Pagination";
import SearchBar from "../../components/SearchBar";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplyIcon from "@mui/icons-material/Reply";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  useLazyDeleteCustomerSupportByIdQuery,
  useLazyGetAllCustomerQuery,
} from "../../services/customerSupport";
import { errorToast, successToast } from "../../helpers";
import { useParams } from "react-router-dom";
import WarnModal from "../../components/modals/WarnModal";
import { usePostRevertQueryMutation } from "../../services/customerSupport";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import Loader from "../../helpers/Loader";
import { Forward } from "@mui/icons-material";
import ForwardQuary from "../../components/modals/ForwardQuary";
import {
  useLazyDeleteInquiryByIdQuery,
  useLazyGetAllInquiryQuery,
  usePostRevertInQueryMutation,
} from "../../services/inquiry";
import { INQUIRY_TYPE } from "../../helpers/constants/enums";
import { formatLabel } from "../../utils/helperFunctions";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Inquiry = () => {
  const [revertQuery] = usePostRevertInQueryMutation();
  const [revertError, setRevertError] = useState<boolean>(false);
  const [value, setValue] = React.useState(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [page, setPage] = useState(1);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selId, setSelId] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [openForward, setOpenForward] = useState<boolean>(false);
  const [revertQueryInput, setRevertQueryInput] = useState("");
  const [deleteCustomerSupportById] = useLazyDeleteInquiryByIdQuery();

  const [CustomerSupportList] = useLazyGetAllInquiryQuery();
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [openWarn, setOpenWarn] = useState(false);

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const fetchData = async (page: number, search: string) => {
    setLoading(true);
    try {
      const response = await CustomerSupportList({
        // status: 1,
        page,
        search,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setRows(response?.data?.data);
        setTotalCount(response?.data?.total);
      } else {
        setRows([]);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleRevertQuery = async () => {
    setLoading(true);
    try {
      let body = {
        ...(revertQueryInput.length ? { revert: revertQueryInput } : {}),
        inquiryId: selId,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await revertQuery({
        body: encryptedBody,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        successToast("Inquiry reverted successfully");
        fetchData(page, searchTerm);
        setOpen(false);
      }
    } catch (error: any) {
      setLoading(false);
      console.error(error);
      errorToast(error?.message || "");
    }
  };

  const table = (
    <TableContainer className="table_container">
      <Box className="heading"></Box>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">S.No</TableCell>
            <TableCell>User Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Queries</TableCell>
            <TableCell>Tutor Name</TableCell>
            <TableCell>Tutor Email</TableCell>
            <TableCell>Reply</TableCell>
            <TableCell>Tutor Reply</TableCell>
            <TableCell>Date & Time</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.length > 0 ? (
            rows.map((row: any, i: any) => (
              <TableRow key={row._id}>
                <TableCell align="center">{(page - 1) * 10 + i + 1}</TableCell>
                <TableCell>{row?.parent?.name || "-"}</TableCell>
                <TableCell>{row?.parent?.email || "-"}</TableCell>
                <TableCell>{formatLabel(INQUIRY_TYPE[row?.type])}</TableCell>
                <TableCell>{row?.tutor?.userName}</TableCell>
                <TableCell>{row?.tutor?.email}</TableCell>
                <TableCell>{row?.revert || "-"}</TableCell>
                <TableCell>{row?.tutorRevert || "-"}</TableCell>
                <TableCell>
                  {new Date(row?.createdAt).toLocaleString()}
                </TableCell>
                <TableCell>
                  <Box className="table_actions">
                    <IconButton
                      onClick={() => {
                        setOpen(true);
                        setSelId(row?._id);
                      }}
                      id="abvd2"
                    >
                      <ReplyIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setOpenForward(true);
                        setSelId(row?._id);
                      }}
                      id="abvd2"
                    >
                      <Forward />
                    </IconButton>
                    <IconButton
                      id="abvd"
                      onClick={() => {
                        setSelectedId(row?._id);
                        setOpenWarn(true);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body1" color="textSecondary">
                    No inquiries found
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
  useEffect(() => {
    fetchData(page, debouncedSearchTerm);
  }, [value, page, debouncedSearchTerm]);

  const handleDeeletequery = async (userId: any) => {
    try {
      const response = await deleteCustomerSupportById({ id: userId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Query deleted successfully");
        fetchData(page, searchTerm);
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || "");
    }
  };
  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setRows([]);
  };

  let totalPages = Math.ceil(totalCount / 10);
  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1>Manage Inquiries</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            {/* <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Queries Received" {...a11yProps(0)} />
              <Tab label="Complaints/Disputes" {...a11yProps(1)} />
            </Tabs> */}
            {/* <CustomTabPanel value={value} index={0}> */}
            <Box className="cards_header">{/* <SearchBar /> */}</Box>
            {table}
            {/* </CustomTabPanel> */}
            {/* <CustomTabPanel value={value} index={1}>
              <Box className="cards_header"></Box>
              {table}
            </CustomTabPanel> */}
          </Box>
        </Card>
      </div>

      <Dialog open={open} onClose={handleClose} className="revert_dialog">
        <DialogTitle>Revert Query</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="revert-query-input"
            label="Revert Query"
            type="text"
            fullWidth
            sx={{ border: "aliceblue" }}
            value={revertQueryInput}
            onChange={(e) => {
              let value = e.target.value;

              // Remove leading spaces only once, not globally
              if (value.length === 1 && value === " ") return;

              // Prevent typing beyond 200 characters
              if (value.length > 200) {
                setRevertError(true);
                return;
              }

              setRevertQueryInput(value);
              setRevertError(false);
            }}
            error={revertError}
            helperText={
              revertError ? "Revert query can't be more than 200 words." : ""
            }
          />
        </DialogContent>

        <DialogActions>
          <Button sx={{ background: "#65a442" }} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            sx={{ background: "#65a442" }}
            onClick={handleRevertQuery}
            disabled={revertError || revertQueryInput.trim().length === 0}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}
      <WarnModal
        open={openWarn}
        setOpen={setOpenWarn}
        handleDelete={() => {
          handleDeeletequery(selectedId);
        }}
        // handleDelete={() => handleDeeletequery(selectedId)}
        name="query"
      />
      <ForwardQuary
        open={openForward}
        setOpen={setOpenForward}
        handleDelete={() => {
          handleRevertQuery();
        }}
        // handleDelete={() => handleDeeletequery(selectedId)}
        name="query"
      />
    </MainContainer>
  );
};

export default Inquiry;
